import ICashBase from "./ICashBase";
import IAmount from "./IAmount";
import ICashFinancing from "./ICashFinancing";

export default class CashBase implements ICashBase {
    constructor(public amount?: IAmount, public financing?: ICashFinancing) {}
}
